var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidInvitation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.247 33.6861C30.9458 42.8669 29.4182 52.7728 29.4182 52.7728L30.2096 76.0186L30.3647 92.4974C30.3647 92.4974 31.9338 118.929 31.961 121.819L32.2998 145.434C32.4462 154.8 36.9938 162.196 42.4772 161.92L128.695 159.142C134.16 158.999 138.547 151.348 138.516 141.979L137.463 30.1972C137.297 20.7987 132.75 13.4355 127.286 13.7445L41.0491 16.5232C35.5836 16.6295 31.1974 24.3138 31.247 33.6861Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 59.933C29.4859 59.8674 29.4853 59.8018 29.4847 59.7362C29.5436 53.008 29.7859 46.2739 30.3341 39.5627C30.7737 34.2988 31.4359 28.8636 33.3722 24.5357C35.6087 19.6076 38.8158 17.4863 42.9693 15.5315C47.2175 13.5321 50.5024 14.6326 54.2758 14.9047C71.185 16.1645 88.1285 16.7341 105.055 15.4669C112.225 14.9406 119.411 14.0528 126.608 14.1818C132.336 14.2597 141.434 12.851 143.899 23.5009C144.749 27.2795 144.727 31.4145 144.684 35.4517C144.222 73.0026 143.781 110.586 143.34 148.136C143.309 151.32 143.179 154.769 141.855 157.108C140.431 159.55 136.054 160.051 136.054 160.051C136.054 160.051 72.0592 165.198 40.042 167.804C39.0438 167.869 38.005 167.936 37.1013 167.21C35.519 165.85 35.1006 162.55 34.8696 159.67C33.7837 146.088 32.6977 132.506 31.8152 118.885",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0957 99.8555L119.58 101.16",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.096 121.984L61.5138 122.774",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.096 144.113L61.5138 144.903",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6003 42.4821C80.7075 37.9793 86.1545 33.9668 91.8818 30.4886C93.4258 29.3394 95.1615 28.5404 96.9878 28.1382C99.0751 27.9519 101.164 28.4754 102.972 29.6382C102.972 29.6382 103.045 29.6385 103.065 29.7073C103.552 29.9725 104.028 30.272 104.505 30.583C109.682 34.0378 114.241 39.0931 116.158 45.4435C116.503 46.6103 116.763 47.8059 116.934 49.0187C116.934 49.0187 116.934 49.0187 116.934 49.0187C117.39 52.5236 117.175 56.0954 116.302 59.504C115.079 64.1047 112.982 68.3664 110.151 72.006C106.838 76.6109 102.37 80.0383 97.3033 81.8603C95.3248 82.5192 93.2719 82.8659 91.2057 82.8902C84.9768 82.9578 78.685 80.4375 73.1646 77.0959C72.0965 76.4662 71.0595 75.7743 70.0581 75.0231C68.2186 73.7337 66.6068 72.0865 65.3012 70.1616C59.1097 60.3485 69.1099 48.5482 75.6003 42.4821Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0088 32.1614C95.4555 30.792 102.342 32.6767 107.475 36.7497C109.552 38.3966 111.348 40.4052 112.704 42.6857C115.723 47.7607 116.69 53.914 115.951 59.7715C115.212 65.629 112.842 71.2045 109.627 76.1578C107.165 79.9521 104.149 83.4644 100.361 85.9382C96.5735 88.412 91.9512 89.7837 87.4733 89.1365C83.5903 88.5758 80.0439 86.5535 77.0332 84.0388C70.3818 78.4826 65.9995 70.3264 64.8825 61.7324C64.0136 55.0457 65.1999 47.8517 69.3752 42.5583C73.9919 36.7053 81.3815 34.0313 88.3832 32.3048C88.5914 32.2536 88.7995 32.2058 89.0088 32.1614Z",
    fill: "#F4526B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5687 68.763C75.3254 68.9824 75.0977 69.2064 74.8879 69.4356C71.6319 73.0122 75.958 73.3478 80.1415 71.5331C89.0921 67.6514 97.7258 62.6168 104.9 56.9921C106.474 55.7575 108.046 54.4179 108.673 53.1354C109.3 51.8529 108.595 50.7117 106.723 50.9932C105.643 51.1555 104.448 51.7295 103.349 52.2997C100.889 53.5744 98.5104 54.9597 96.1384 56.3416C90.9317 59.3735 85.7232 62.4063 80.5169 65.4391C78.7518 66.4663 76.9146 67.5503 75.5687 68.763Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5261 75.7293C96.769 75.9 97.0154 76.0553 97.2659 76.1926C101.172 78.3198 101.189 74.2362 99.0161 70.8158C94.3682 63.4978 88.564 56.7578 82.2661 51.5134C80.8837 50.3627 79.3941 49.2401 78.0342 48.9775C76.6744 48.7148 75.5595 49.6486 75.9888 51.3098C76.2364 52.2687 76.9141 53.2318 77.5806 54.1078C79.0708 56.0669 80.6681 57.9247 82.2613 59.7767C85.7573 63.8424 89.2542 67.9096 92.7509 71.9747C93.9354 73.3532 95.1835 74.7843 96.5261 75.7293Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1377 48.9844L100.063 73.5417M105.411 52.1875C104.983 52.6146 87.0505 63.7543 78.1377 69.2708",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9329 34.2578C72.4053 34.6229 60.1135 47.5072 60.4786 63.0348C60.8312 78.0495 72.9194 90.1365 87.934 90.4902C103.463 90.4902 119.144 74.7533 119.144 59.2803C119.13 45.0118 104.962 34.2578 87.9329 34.2578Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidInvitation);
export default __webpack_public_path__ + "static/media/invalid-invitation.87afab9fddfe8e72ff8e97568a5c7c59.svg";
export { ForwardRef as ReactComponent };